<template>
  <div class="main-layout">
    <CCollapseItem>
      <template slot="title-left"> 绿色通道申请 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <div></div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>
      <div class="div-scroll">
        <c-table
          :data="pageData"
          :tableColumns="tableColumns"
          :pagination="pageParams"
          @change="pageGet"
          @selectionChange="selectionChange"
          v-loading="pageLoading"
          @showDetail="handleToDetail"
        >
        </c-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import Configs from "./data/green";
import MPage from "@/mixins/MPage.js";
let mPage = MPage({
  pagePath: "/welcome-live/green/apply/listPage?status=1",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {},
});
export default {
  name: "",
  mixins: [mPage],
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      SUCCESS_CODE: "",
      isFold: false,
      searchItems,
      tableColumns,
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
  },
  mounted() {},
  methods: {
    selectionChange() {},
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    // 查看详情
    handleToDetail(data) {
      this.$router.push({
        path: "/welcome/teacher/predicted/greenDetail",
        query: { id: data.id, type: "todo" },
      });
    },
  },
};
</script>
